import { FC } from 'react';
import Switch from 'react-switch';

interface Props {
  checked: boolean;
  disabled?: boolean;
  onChange: (value: boolean) => void;
  className?: string;
}

const SwitchComponent: FC<Props> = ({ checked, onChange, className = 'mt-2', disabled }) => (
  <label className={className}>
    <Switch
      checkedIcon={false}
      uncheckedIcon={false}
      onColor={!disabled ? '#007AC1' : '#afafaf'}
      onChange={onChange}
      checked={checked}
      disabled={disabled}
    />
  </label>
);

export default SwitchComponent;
